__webpack_require__.p = "https://webusstatic.yo-star.com/arknights-jp/ark-jp-wangsweiqichallenge-h5/prod/arkjpwangsweiqichallengeh5/";